import { defineComponent as _defineComponent } from 'vue'
import { twMerge } from 'tailwind-merge'
import { computed } from 'vue'

interface LEditableTextProps {
  value: string
  placeholder?: string
  fontStyles?: string[] | string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LEditableText',
  props: {
    value: null,
    placeholder: null,
    fontStyles: null
  },
  emits: ['input', 'focusout'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: string
  placeholder?: string
  fontStyles?: string[] | string
};




const inputValue = computed({
  get() {
    return props.value
  },
  set(value) {
    emit('input', value)
  },
})

function onFocusout() {
  emit('focusout')
}

// remove focus from input field after pressing enter
function onEnter(e: Event) {
  const el = e.target as HTMLInputElement
  el.blur()
}

return { __sfc: true,props, emit, inputValue, onFocusout, onEnter, twMerge }
}

})